import { InputWrapper } from '@components/Input/index.style'
import { TextareaWrapper } from '@components/Textarea/index.style'
import { clamp } from '@styles/utils/conversion.style'
import { TextBody, textStylesConfig, getStyles } from '@styles/vars/textStyles.style'
import { mq } from '@styles/vars/media-queries.style'
import styled, { css } from 'styled-components'
import { AnimateSlideInContent } from '@components/animation/AnimateSlideIn/index.style'
import { RichTextMain } from '@components/RichText/index.style'
import { colors } from '@styles/vars/colors.style'

const textareaTextStyles = css`
  ${getStyles({ ...textStylesConfig.body2 })}
`
const fontSizeMax = textStylesConfig.body2.size.max
export const FormMain = styled.form`
  

  ${AnimateSlideInContent},
  ${InputWrapper},
  ${TextareaWrapper} {
    width: 100%;
  }
  select {
    padding-bottom: 10px;
    ${textareaTextStyles}
    border: none;
  }
  div[class*="SelectWrapper"] {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 100%;
      left: 0;
      height: 0.1rem;
      width: 100%;
      background-color: currentColor;
      opacity: 0.3;
    }

  }
  select + svg {
    width: 16px;
    top: 4px;
    right: 10px;
  }
  select option {
    background-color: ${colors.charcoal};
    color: white;
  }
  select option:disabled {
    background-color: ${colors.charcoal};
    color: rgba(255,255,255,0.6);
  }
  div{
    width: 100%;
  }
`

export const FormPrivacy = styled.div`
  position: relative;
  overflow: hidden;
`
export const Fieldset = styled.div`
  position: relative;
  display: grid;
  ${clamp('grid-gap', 20, 40)}
  ${clamp('margin-bottom', 20, 40)}
  justify-items: start;
`

export const FormCheckbox = styled.input`
  position: absolute;
  top: 0;
  right: 100%;
`

export const FormCheckboxMarker = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 2.8rem;
  height: 2.8rem;
  pointer-events: none;
  border: 0.1rem solid currentColor;

  ${mq.tabletP} {
    top: 50%;
    transform: translateY(-50%);
  }
`

export const FormCheckboxLabel = styled.label`
  cursor: pointer;

  ${RichTextMain} {
    padding-left: 4.8rem;
  }

  ${TextBody} {
    ${clamp('font-size', 14, 16)}
  }
`
